import React from 'react';

const IconHeart = ({ onClick }) => {
	return (
		<div className='IconHeart' onClick={onClick}>
			<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
				<g clipPath="url(#clip0_408_255)">
					<path d="M13.75 2.5C12.3 2.5 10.9084 3.175 10 4.24167C9.09169 3.175 7.70002 2.5 6.25002 2.5C3.68335 2.5 1.66669 4.51667 1.66669 7.08333C1.66669 10.2333 4.50002 12.8 8.79169 16.7L10 17.7917L11.2084 16.6917C15.5 12.8 18.3334 10.2333 18.3334 7.08333C18.3334 4.51667 16.3167 2.5 13.75 2.5ZM10.0834 15.4583L10 15.5417L9.91669 15.4583C5.95002 11.8667 3.33335 9.49167 3.33335 7.08333C3.33335 5.41667 4.58335 4.16667 6.25002 4.16667C7.53335 4.16667 8.78335 4.99167 9.22502 6.13333H10.7834C11.2167 4.99167 12.4667 4.16667 13.75 4.16667C15.4167 4.16667 16.6667 5.41667 16.6667 7.08333C16.6667 9.49167 14.05 11.8667 10.0834 15.4583Z" fill="black" />
				</g>
				<defs>
					<clipPath id="clip0_408_255">
						<rect width="20" height="20" fill="white" />
					</clipPath>
				</defs>
			</svg>
		</div>
	)
}

export default IconHeart;